export enum EPollActionType {
  success = 'poll/ACTION_SUCCESS',
  failure = 'poll/ACTION_FAILURE',
  fetching = 'poll/ACTION_REQUEST',
}
